import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { STORAGE_KEYS } from '../config/app.config';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import it from './locales/it.json';
import de from './locales/de.json';
import tr from './locales/tr.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar },
  es: { translation: es },
  it: { translation: it },
  de: { translation: de },
  tr: { translation: tr },
  zh: { translation: zh },
  ru: { translation: ru },
};

const fallbackLng = 'en';

const detectorOptions = {
  order: ['localStorage', 'navigator'],
  lookupLocalStorage: STORAGE_KEYS.LANGUAGE,
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    detection: detectorOptions,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
